import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import styled from 'styled-components';
import { withFormik } from 'formik';
import * as yup from 'yup';
import { withTranslation } from 'react-i18next';

import { capfl } from 'common/utils';

import SelectGroup from 'common/components/styleguide/form/SelectCustomGroup';
import Icon from 'common/components/styleguide/Icon';
import Button from 'common/components/styleguide/Button';
import Numstepper from 'common/components/_base/NumStepper';

import { setPageData, togglePageModal } from 'common/actions/PageActions';
import { fetchPossibleDeliveries } from 'common/actions/ReservationActions';
import { addToCart } from 'common/actions/CartActions';

import DetailPrice from './Price';
import Hooks from './Hooks';
import HardHooks from './HardHooks';

import { PRODUCT_HARD_HOOK_TYPE } from 'common/constants/ProductConstants';
import { ESHOP_TYPE_B2B_LOCKED } from 'common/constants/SiteConstants';

import { getWebInstanceEshopTypeSelector } from 'common/selectors';
import { isUserLoggedSelector } from 'common/selectors/user';

import SS from 'common/components/product/_styles';
const S = {};

S.SelectGroup = styled(SelectGroup)`
  flex: 3;
`;

S.Wrapper = styled.div`
  display: flex;
  margin-left: 10px;
  flex: 1;
`;

S.WrapperButton = styled(S.Wrapper)`
  flex: 1;
`;

S.Button = styled(Button)`
  width: 100%;
`;

S.FormWrapper = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: ${({ theme }) => _.get(theme, 'border.default.width')} ${({ theme }) => _.get(theme, 'border.default.style')} ${({ theme }) => _.get(theme, 'border.default.color')};
  border-bottom: ${({ theme }) => _.get(theme, 'border.default.width')} ${({ theme }) => _.get(theme, 'border.default.style')} ${({ theme }) => _.get(theme, 'border.default.color')};
  padding: 10px 0;
  margin: 10px 0;
`;

S.UnableToOrder = styled.section`
  border-top: ${({ theme }) => _.get(theme, 'border.default.width')} ${({ theme }) => _.get(theme, 'border.default.style')} ${({ theme }) => _.get(theme, 'border.default.color')};
  padding: 15px;
  margin: 0;
  font-weight: bolder;
`;

class DetailForm extends PureComponent {
  constructor(props) {
    super(props);
    this.onShowReservationModalClick = this.onShowReservationModalClick.bind(
      this
    );
  }
  onShowReservationModalClick(e) {
    e.preventDefault();
    const { showReservationModal, product } = this.props;
    showReservationModal(product);
  }
  render() {
    const {
      data,
      values,
      errors,
      touched,
      handleSubmit,
      setFieldValue,
      setFieldTouched,
      isSubmitting,
      isValid,
      setSizeForReservation,
      setCountForReservation,
      eshopType,
      isLogged = false,
      t
    } = this.props;
    return (
        <Fragment>
            <SS.Block>
              <DetailPrice data={data} />
            </SS.Block>
            <form onSubmit={handleSubmit}>
                <S.FormWrapper>
                    <S.SelectGroup
                        selectProps={{
                        id: 'size',
                        name: 'size',
                        defaultValue: values.size ? values.size : null,
                        options: _.map(store, item => {
                            return { value: item.id, label: item.name };
                        }),
                        setFieldValue,
                        setFieldTouched,
                        onChange: value => {
                            setSizeForReservation(value);
                        }
                        }}
                        error={touched.size && errors.size ? errors.size : ''}
                        label={capfl(t('size'))}
                    />
                    {selectedStore ? (
                      <S.Wrapper>
                        <Numstepper
                            min={1}
                            max={selectedStore.count}
                            name="count"
                            onChange={value => {
                            setCountForReservation(value);
                            }}
                            startValue={1}
                            setFieldValue={setFieldValue}
                            setFieldTouched={setFieldTouched}
                            customStyle={{input:{width:'100%'}}}
                        />
                      </S.Wrapper>
                    ) : (
                        ''
                    )}
                    <S.WrapperButton>
                        <S.Button type="submit" disabled={!isValid || isSubmitting}>
                        {isSubmitting ? (
                            <Icon className="nc-circle-02-1" />
                        ) : (
                            capfl(t('add to cart'))
                        )}
                        </S.Button>
                    </S.WrapperButton>
                </S.FormWrapper>
            </form>
            <HardHooks data={hardHooks} />
            <Hooks data={productHooks} />
        </Fragment>
    );

  }
}

const getFormMessages = t => {
  return {
    size: { required: capfl(`${t('size')} ${t('is required')}!`) },
    count: {
      required: capfl(`${t('count')} ${t('is required')}!`)
    }
  };
};

const formikEnhancer = withFormik({
  isInitialValid: true,
  enableReinitialize: true,
  mapPropsToValues: props => {
    const { data } = props;
    return {
      size: _.get(data, 'store[0].id', null),
      count: 1
    };
  },
  validationSchema: ({ t }) => {
    const messages = getFormMessages(t);
    return yup.object().shape({
      size: yup.mixed().required(messages.size.required),
      count: yup.number().required(messages.count.required)
    });
  },
  handleSubmit: (values, { props, setSubmitting }) => {
    const { data, productHooks, showProductHooksModal, addItemToCart } = props;
    const { id } = data;
    const { size, count } = values;
    addItemToCart(id, size, count);
    if (!_.isEmpty(productHooks)) {
      showProductHooksModal();
    }
    setSubmitting(false);
  }
});

const EnhancedDetailForm = formikEnhancer(DetailForm);

const makeMapStateToProps = () => {
  const getWebInstanceEshopType = getWebInstanceEshopTypeSelector();
  const isUserLogged = isUserLoggedSelector();
  return (state, props) => {
    return {
      eshopType: _.toNumber(getWebInstanceEshopType(state, props)),
      isLogged: isUserLogged(state, props)
    };
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showProductHooksModal: () => {
      dispatch(togglePageModal('product_hooks', true));
    },
    addItemToCart: (id, sizeId, count) => {
      dispatch(addToCart({ productId: id, sizeId, count }));
    },
    showReservationModal: product => {
      dispatch(fetchPossibleDeliveries(product));
      dispatch(togglePageModal('product_reservation', true));
    },
    setSizeForReservation: values => {
      dispatch(setPageData(values, 'reservation', 'size'));
    },
    setCountForReservation: value => {
      dispatch(setPageData(value, 'reservation', 'count'));
    }
  };
};

const EnhancedDetailFormConnected = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(EnhancedDetailForm);

export default withTranslation()(EnhancedDetailFormConnected);
